import api from './index.js'

export default {

  // 当事者一覧を取得
  getSelfHelpGroups() {
    return api.get('users/groups')
  },

  // ボランティアユーザー一覧を取得
  getVolunteers() {
    return api.get('users/volunteers')
  },

  // 本人一覧を取得
  getUsers () {
    return api.get('users')
  }

}
